const FilterOptions = {
    all: 'ALL',
    optouts: 'OPTOUTS',
    pending: 'PENDING',
    failed: 'FAILED',
    delivered: 'DELIVERED',
  };
  
  export default FilterOptions;